import { useCallback, useEffect, useRef, useState } from "react";
import Menu from "./Menu";
import { Dimensions } from "react-native";
import StyleSheetRW from "core/StyleSheetRW";
import AddTimeOffRequest from "src/components/AddTimeOffRequest";
import React from 'react'
import { getLocalStorageItem } from "core/helpers";
import { db } from "@react-native-firebase/database";
import { get, ref, remove } from "firebase/database";
import { formatDate, } from "src/utils/Date&TimeUtils";
import Dialog from "src/components/Dialog";
import Loader from "src/components/Loader";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import UserLeaveSummary from "./UserLeaveSummary";
import { useLocation } from "react-router-dom";


const UserTimeOffRequest = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showUserSummary, setShowUserSummary] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [recordEntryDate, setRecordEntryDate] = useState("");
  const [recordEntryData, setRecordEntryData] = useState<any>(null);
  const screenWidth = Dimensions.get('window').width;
  const [showToast, setShowToast] = useState(false);
  const [showToast2, setShowToast2] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const tableHeadstyle = { ...styles.tableHead, display: screenWidth < 600 ? 'none' : 'table-cell' };
  const tableDataStyle = { ...styles.tableData1, display: screenWidth < 600 ? 'none' : 'table-cell' }
  const [showLoader, setShowLoader] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0, visible: false });
  const url = new URLSearchParams(useLocation().search)

  useEffect(() => {
    const showAddTimeOffRequestDialog = url.get('showAddTimeOffRequestDialog') !== null;
    setIsVisible(showAddTimeOffRequestDialog)
  }, [])


  const fetchTimeOffList = async () => {
    setShowLoader(true)
    try {
      const loggedinUser = getLocalStorageItem("loggedinUser");
      if (loggedinUser) {
        const dbRef = ref(
          db,
          `timeOffRequest/${loggedinUser.uid}`
        );
        await get(dbRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const data = snapshot.val();
              setShowLoader(false)
              const timeOffLists: any = [];
              Object.keys(data).forEach((requestDate) => {
                const recordArray = Object.keys(data[requestDate]).map((requestUid) => {
                  const { startDate, endDate, availability, reason, status, name, totalhours, leaveType } = data[requestDate][requestUid];
                  return { startDate, endDate, availability, reason, status, name, uid: requestUid, totalhours, leaveType };
                });
                timeOffLists.push({ date: requestDate, timeOffLists: recordArray });
              });
              setTableData(timeOffLists.reverse());
            } else {
              setShowLoader(false)
              console.log("No data available");
              setTableData([]);
            }
          })
          .catch((error) => {
            setShowLoader(false)
            console.error("Failed to retrieve data:", error);
            setTableData([]);
          });
      }
    } catch (error: any) {
      setShowLoader(false)
      console.error("Error reading data:", error.message);
    }
  };

  useEffect(() => {
    fetchTimeOffList();
  }, []);
  const [selectedRow, setSelectedRow] = useState<string>("");
  const handleRowClick = useCallback((event: any, entry: any, date: any) => {
    event.preventDefault();
    const container = scrollContainerRef.current;
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const x = Math.min(event.clientX, containerRect.right - 150); // Adjust the right boundary
      const y = Math.min(event.clientY, containerRect.bottom - 70); // Adjust the bottom boundary
      setDropdownPosition({ x, y, visible: true });
    }
    setRecordEntryDate(date)
    setSelectedRow(entry === selectedRow ? "" : entry);

  }, [selectedRow]);
  const handleDeleteEntry = async (e: React.MouseEvent<HTMLSpanElement>, recordEntryData: any, recordEntryDate: string) => {
    e.stopPropagation();
    setRecordEntryDate(recordEntryDate)
    setRecordEntryData(recordEntryData)
    setToastMessage(`Do you want to delete slot  from ${recordEntryData.startDate} to ${recordEntryData.endDate}`)
    setShowToast(true)
  };

  const handleConfirm = async () => {
    try {
      const loggedinUser = getLocalStorageItem("loggedinUser");
      if (loggedinUser) {
        const dbRef = ref(db, `timeOffRequest/${loggedinUser.uid}/${recordEntryDate}/${recordEntryData.uid}`);
        await remove(dbRef)
          .then(() => {
            console.log("Entry deleted successfully!");
            setSelectedRow("");
            setRecordEntryDate("");
            setRecordEntryData(null);
            setShowToast(false)
            fetchTimeOffList();
          })
          .catch((error) => {
            console.error("Failed to delete entry:", error);
            setShowToast(false)
            setSelectedRow("");
          });
      }
    } catch (error) {
      console.error("Error deleting entry: ", error);
    }
  }

  useEffect(() => {
    const scrollContainer = scrollContainerRef?.current;

    const handleSelectedRow = () => {
      setSelectedRow("");
    };

    const handletouchmove = () => {
      setSelectedRow("");
    };

    const handleClick = () => {
      const isMobile = window.innerWidth < MOBILE_VIEW_WIDTH;
      if (!isMobile) {
        setSelectedRow("");
      }
    };

    if ('ontouchstart' in window) {
      document.body.addEventListener('touchmove', handletouchmove);
    } else {
      document.body.addEventListener('click', handleClick);
    }

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleSelectedRow);
    }

    return () => {
      if ('ontouchstart' in window) {
        document.body.removeEventListener('touchmove', handletouchmove);
      } else {
        document.body.removeEventListener('click', handleClick);
      }
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleSelectedRow);
      }
    };
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
      <Menu />
      {showToast2 && (
        <Dialog
          message={toastMessage}
          onDialogClose={() => setShowToast2(false)}
          isDialogVisible={showToast2}
          title="Reason"
        />)}
      {showToast && (
        <Dialog
          message={toastMessage}
          onDialogClose={() => setShowToast(false)}
          confirm={true}
          isDialogVisible={showToast}
          handleDialogConfirm={handleConfirm}
        />
      )}
      <div style={styles.container}>
        <div ref={scrollContainerRef} style={{ width: screenWidth < 600 ? "90%" : "100%", padding: '0px 0px 0px 20px', height: "100%", overflowY: "scroll", fontSize: 14 }}>
          <div style={{ width: screenWidth < 600 ? "100%" : "97%", fontFamily: "Outfit", }}>
            <div style={{ width: "100%" }}>
              <h1 style={styles.heading}>Leave Requests</h1>
              <button onClick={() => setIsVisible(true)}
                style={{ ...styles.button, cursor: "pointer", marginTop: 26 }}>Add New</button>
              <AddTimeOffRequest onOpen={isVisible} onClose={() => setIsVisible(false)} recordEntryDate={recordEntryDate} fetchTimeOffList={fetchTimeOffList} />
              <button onClick={() => setShowUserSummary(true)}
                style={{ ...styles.button, cursor: "pointer", marginTop: 26, marginLeft: 10 }}>Leave Summary</button>
              <UserLeaveSummary onOpen={showUserSummary} onClose={() => setShowUserSummary(false)} />
            </div>
          </div>
          <div style={{ width: "97%", fontFamily: "Outfit", marginTop: "30px", marginBottom: "30px", position: "relative" }}>

            <table style={styles.tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#2F4858', color: '#FFFFFF' }}>
                  <th style={styles.tableHead}>Applied On</th>
                  <th style={tableHeadstyle}>Unavailability</th>
                  <th style={tableHeadstyle}>Leave Type</th>
                  <th style={styles.tableHead}>Date</th>
                  <th style={tableHeadstyle}>Day</th>
                  <th style={styles.tableHead}>Status</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 && tableData.map((timeOffListEntry: any, index: any) => (
                  <React.Fragment key={index}>
                    <tr style={{
                      backgroundColor: timeOffListEntry.timeOffLists[0].uid === selectedRow.uid ? '#0000FF33' : index % 2 === 0 ? '#2F48581A' : '#D8E6DC',
                    }}
                      onContextMenu={(e) => handleRowClick(e, timeOffListEntry.timeOffLists[0], timeOffListEntry.date)}
                      onClick={screenWidth < MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, timeOffListEntry.timeOffLists[0], timeOffListEntry.date) : undefined}
                    >
                      <td style={{ padding: '15px' }}>{formatDate(timeOffListEntry.date, "DD MMM, YY")}</td>
                      <td style={tableDataStyle}>{timeOffListEntry.timeOffLists[0].availability === "Specify hours" ? `${timeOffListEntry.timeOffLists[0].totalhours} hrs` : timeOffListEntry.timeOffLists[0].availability}</td>
                      <td style={tableDataStyle}>{timeOffListEntry.timeOffLists[0].leaveType}</td>
                      <td style={styles.tableData1}>{formatDate(timeOffListEntry.timeOffLists[0].startDate, "DD MMM, YY") === formatDate(timeOffListEntry.timeOffLists[0].endDate, "DD MMM, YY") ? formatDate(timeOffListEntry.timeOffLists[0].startDate, "DD MMM, YY") : `${formatDate(timeOffListEntry.timeOffLists[0].startDate, "DD MMM, YY")} - ${formatDate(timeOffListEntry.timeOffLists[0].endDate, "DD MMM, YY")}`}</td>
                      <td style={tableDataStyle}>{formatDate(timeOffListEntry.timeOffLists[0].startDate, "DD MMM, YY") !== formatDate(timeOffListEntry.timeOffLists[0].endDate, "DD MMM, YY") ? `${formatDate(timeOffListEntry.timeOffLists[0].startDate, "dddd")}...` : formatDate(timeOffListEntry.timeOffLists[0].startDate, "dddd")}</td>
                      <td style={styles.tableData1}>{timeOffListEntry.timeOffLists[0].status}</td>
                      {timeOffListEntry.timeOffLists[0].uid === selectedRow.uid && (
                        <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 100 }}>
                          <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse' }}>
                            <tbody>
                              <tr>
                                <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                  <span onClick={timeOffListEntry.timeOffLists[0].status === "Applied" ? (e) => handleDeleteEntry(e, timeOffListEntry.timeOffLists[0], timeOffListEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: timeOffListEntry.timeOffLists[0].status === "Applied" ? "pointer" : "not-allowed", color: timeOffListEntry.timeOffLists[0].status === "Applied" ? "#2F4858" : "gray" }} >Delete entry</span>
                                  <span onClick={() => setIsVisible(true)} style={{ ...styles.DropDownspan, }} >Add new</span>
                                  <span onClick={() => { setShowToast2(true); setToastMessage(timeOffListEntry.timeOffLists[0].reason) }} style={{ ...styles.DropDownspan, }} >View Reason</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </tr>
                    {timeOffListEntry.timeOffLists.slice(1).map((record: any, recordIndex: any) => (
                      <tr key={record.uid} style={{ backgroundColor: record.uid === selectedRow.uid ? '#0000FF33' : index % 2 === 0 ? '#2F48581A' : '#D8E6DC' }}
                        onContextMenu={(e) => handleRowClick(e, record, timeOffListEntry.date)}
                        onClick={screenWidth < MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, record, timeOffListEntry.date) : undefined}
                      >
                        <td style={{ padding: "15px" }}></td>
                        <td style={tableDataStyle}>{record.availability === "Specify hours" ? `${record.totalhours} hrs` : record.availability}</td>
                        <td style={tableDataStyle}>{record.leaveType}</td>
                        <td style={styles.tableData1}>{formatDate(record.startDate, "DD MMM, YY") === formatDate(record.endDate, "DD MMM, YY") ? formatDate(record.startDate, "DD MMM, YY") : `${formatDate(record.startDate, "DD MMM, YY")} - ${formatDate(record.endDate, "DD MMM, YY")}`}</td>
                        <td style={tableDataStyle}>{formatDate(record.startDate, "DD MMM, YY") !== formatDate(record.endDate, "DD MMM, YY") ? `${formatDate(record.startDate, "dddd")}...` : formatDate(record.startDate, "dddd")}</td>
                        <td style={styles.tableData1}>{record.status}</td>
                        {record.uid === selectedRow.uid && (
                          <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 100 }}>
                            <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse' }}>
                              <tbody>
                                <tr>
                                  <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                    <span onClick={record.status === "Applied" ? (e) => handleDeleteEntry(e, record, timeOffListEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: record.status === "Applied" ? "pointer" : "not-allowed", color: record.status === "Applied" ? "#2F4858" : "gray" }}>Delete entry</span>
                                    <span onClick={() => setIsVisible(true)} style={{ ...styles.DropDownspan, }} >Add new</span>
                                    <span onClick={() => { setShowToast2(true); setToastMessage(record.reason) }} style={{ ...styles.DropDownspan, }} >View Reason</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showLoader && (
        <Loader />
      )}

    </div>

  )
}

const styles = StyleSheetRW.create(() => ({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
    overflow: "hidden"
  },
  heading: { fontWeight: '700', fontSize: 36, color: '#2F4858', marginTop: 20, width: '100%' },
  button: {
    backgroundColor: '#2F4858',
    padding: "10px 30px",
    borderRadius: 100,
    color: 'white',
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,

  },
  tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
  tableHead: { padding: '15px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300', fontSize: 14 },
  tableStyle: { width: "100%", borderCollapse: 'collapse', backgroundColor: '#FFFFFF66', height: "100%" },
  tableData1: { padding: '15px', borderLeft: '1px solid #2F485880' },
  DropDownspan: { fontFamily: "Outfit", fontSize: 14, fontWeight: "300", textAlign: "left", color: "#2F4858", cursor: "pointer", }
}))

export default UserTimeOffRequest